module.exports = __webpack_public_path__ + "img/honer10.1e9a46c5.jpg";